import { Reveal, SectionHeading } from "./Reveal";
import { TeamMemberCard } from "./TeamMemberCard";
import { APPROACH, TEAM } from "@/data/content";

const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32"
  >
    <div className="grid grid-cols-1 gap-16 lg:grid-cols-2">
      <div>
        <SectionHeading
          number="01"
          label="About"
          title="Capital decisions require more than a lender list."
        />
        <Reveal delay={0.1}>
          <p className="mt-8 text-base font-light leading-relaxed text-slate-400 sm:text-lg">
            Businesses often have multiple financing options — but the
            appropriate solution depends on the business, its cash flows,
            collateral, leverage, purpose of funding, urgency and existing
            capital structure.
          </p>
          <p className="mt-6 text-base font-light leading-relaxed text-slate-400 sm:text-lg">
            Jeet Advisory Services works across the capital spectrum to
            identify suitable financing routes and coordinate with relevant
            capital providers — from banks and NBFCs to private-credit funds
            and structured-credit investors.
          </p>
        </Reveal>

        <div className="mt-12">
          <Reveal delay={0.15}>
            <p className="mb-6 font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">
              Our approach
            </p>
          </Reveal>
          <div className="grid grid-cols-2 gap-px border border-white/10 bg-[#0D1220]/10 sm:grid-cols-4">
            {APPROACH.map((a, i) => (
              <Reveal key={a.key} delay={0.1 + i * 0.08} className="h-full">
                <div
                  data-testid={`approach-${a.key}`}
                  className="group h-full bg-[#0B0F17] p-5 transition-colors duration-500 hover:bg-[#111827]"
                >
                  <span className="font-mono2 text-[10px] tracking-[0.25em] text-[#F2824F]">
                    0{i + 1}
                  </span>
                  <p className="mt-3 font-display text-xl text-slate-200 transition-colors duration-300 group-hover:text-[#F26122]">
                    {a.label}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <Reveal delay={0.2} className="lg:pl-8">
        <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">
          Leadership
        </p>
        <div data-testid="leadership-grid" className="mt-6 grid gap-8">
          {TEAM.map((member) => (
            <TeamMemberCard key={member.name} member={member} />
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
